import { setNotification } from "../reduser/notificationSlice";

export const showNotification = (dispatch, message, type = "info") => {
  const isAtTop = window.scrollY < 100;

  const position = isAtTop ? "top-center" : "bottom-center";

  dispatch(
    setNotification({
      message,
      type,
      position,
    }),
  );

  if (!isAtTop) {
    setTimeout(() => {
      const notificationElement = document.querySelector(".custom-toast");
      if (notificationElement) {
        notificationElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 100);
  }
};
